import { createContext } from "react";
import { type User } from "../types";

export interface AuthContextType {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (userData: Record<string, unknown>) => Promise<void>;
  googleLogin: (idToken: string) => Promise<void>;
  logout: (reason?: string) => Promise<void>;
  hasRole: (role: string) => boolean;
  hasRoles: (roles: string[]) => boolean;
  hasPermission: (resource: string, action: string) => boolean;
  hasPermissions: (
    permissions: Array<{ resource: string; action: string }>,
  ) => boolean;
  updateUser: (userData: Partial<User>) => Promise<void>;
  getAccessToken: () => string | null;
  setTokens: (tokens: { access: string; refresh: string }) => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
